<template>
    <div class="containerht">
        <div v-if="!showDetails">
            <div class="containerht">
                <el-link :underline="false">
                    <el-button
                    size="medium"
                    round
                    @click="addnewopenid">
                    {{ $t("message.新增") }}
                    </el-button>
                </el-link>
            </div>
            <el-table
          ref="table"
          :data="appIDs"
          stripe
          border
          :height="tableHeight"
          style="width: 100%"
        >
          <el-table-column
            width="200"
            :label="$t('message.操作')"
            align="center"
          >
            <template slot-scope="scope">
              <el-button-group>
                <el-button
                  size="mini"
                  round
                  type="normal"
                  icon="el-icon-view"
                  @click="
                    setappID(scope.row);
                  "
                ></el-button>
                <el-button
                  size="mini"
                  round
                  type="normal"
                  icon="el-icon-delete"
                  @click="
                    deleteopenid(scope.row);
                  "
                ></el-button>
              </el-button-group>
            </template>
          </el-table-column>

          <el-table-column prop="appid" label="appID" width="150">
          </el-table-column>

          <el-table-column prop="openid" label="openID" width="150"> </el-table-column>

          <el-table-column prop="name" label="name"> </el-table-column>
        </el-table>
        </div>
        <div v-if="showDetails">
            <div class="containerht">
                <el-link :underline="false">
                    <el-button
                    size="medium"
                    round
                    @click="reset"
                    icon="el-icon-back"
                    >
                    {{ $t("message.返回") }}
                    </el-button>
                    <el-button
                    size="medium"
                    round
                    @click.native="save()"
                    >
                    <i class="iconfont">&#xe769;</i>
                    {{ $t("message.保存") }}
                    </el-button>
                </el-link>
            </div>
        <div class="selecttab pad">
            <el-form ref="form" :model="form" label-width="120px" label-position='left'>
                    <el-form-item :label="$t('message.商家名')" >
                    <el-input v-model="form.openname"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('message.商家描述')" >
                    <el-input v-model="form.opencomment"></el-input>
                    </el-form-item>
            </el-form>
        </div>
        <div class="topinfo pad">
            <div>
                <span class="tittle">{{$t('message.API调取统计')}}</span>
            </div>
            <div class="content">
                <div class="child">
                    <div class="logo">
                        <img class="img" src="../../assets/img/logo.a13e.svg" alt="logo">
                    </div>
                    <div class="contentc">
                        <div class="percent123 canclick" @click="apicontact">
                            <span>{{apicount.openApi+'/'+apicount.maxapi}}</span>
                        </div>
                        <p>{{$t('message.接口比例')}}</p>
                    </div>
                </div>
                <div class="child">
                    <div class="logo">
                        <img class="img" src="../../assets/img/logo.a13e.svg" alt="logo">
                    </div>
                    <div class="contentc">
                        <div class="percent123 ">
                            <span>{{apicount.secondLimit}}</span>
                        </div>
                        <p>{{$t('message.每秒可调用接口次数')}}</p>
                    </div>
                </div>
                <div class="child">
                    <div class="logo">
                        <img class="img" src="../../assets/img/logo.a13e.svg" alt="logo">
                    </div>
                    <div class="contentc">
                        <div class="percent123 ">
                            <span>{{apicount.resDate}}</span>
                        </div>
                        <p>{{$t('message.重置时间')}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="cinfo pad">
            <div>
                <span class="tittle">{{$t('message.API认证信息')}}</span>
                <span class="canclick" style="margin-left:10px">{{$t('message.查看API文档')}}</span>
                <span class="canclick" style="margin-left:10px">{{$t('message.查看API说明')}}</span>
            </div>
            <div class="warring">
                <p>{{$t('message.安全提示')}}</p>
                <p>{{$t('message.权限提示')}}</p>
            </div>
            <div class="form">
                <el-form ref="form" :model="form" label-width="120px" label-position='left'>
                    <el-form-item label="appid" >
                    <el-input v-model="form.appid" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="openid" >
                    <el-input v-model="form.openid" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="access-key" >
                    <el-input v-model="form.name" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="accessKeySecret">
                        <div style="display:flex">
                            <el-input v-model="form.pwd" :show-password='showpwd' disabled></el-input>
                            <div class="canclick" style="width:53%;margin-left:3%"><el-button type="text" style="margin-right:3%" @click="showpwdfunc">{{showpwd?$t('message.显示'):$t('message.隐藏')}}</el-button>
                            <span  @click="resetaccess">{{$t('message.重置accessKeySecret')}}</span>
                            </div>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="lastinfo pad">
            <div>
                <span class="tittle">{{$t('message.白名单')}}</span>
            </div>
            <div class="inforemark">
                <p>{{$t('message.ip域名备注')}}</p>
                <p>{{$t('message.ip域名提示')}}</p>
                <p>{{$t('message.最多可以创建5个服务器IP或域名')}}</p>
            </div>
            <div style="margin-top:25px">
                <el-button type="primary" @click="addiphost">{{$t('message.添加IP或域名')}}</el-button>
                <el-table :data="data">
                    <el-table-column :label="$t('message.类型')" width="80" align="center" prop="type">
                        <template slot-scope="scope">
                            <span >{{scope.row.type==0?'IP':$t('message.域名')}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('message.内容')" align="center" prop="content"></el-table-column>
                    <el-table-column :label="$t('message.操作')" align="center">
                        <template slot-scope="scope">
                            <span class="canclick" style="margin-left:10px" @click="deleteiphost(scope.$index)">{{$t('message.删除')}}</span>
                        </template>
                        </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="lastinfo pad">
            <div>
                <span class="tittle">{{$t('message.openAPI接口管理')}}</span>
            </div>
            <div class="inforemark">
                <p>{{$t('message.查阅配表')}}</p>
            </div>
            <div style="margin-top:25px">
                <el-button type="primary" @click="addinterfacelimit">{{$t('message.添加接口限制')}}</el-button>
                <el-table :data="interfacelimit">
                    <el-table-column :label="$t('message.openID')" width="80" align="center" prop="openid"></el-table-column>
                    <el-table-column :label="$t('message.接口ID')" align="center" prop="interfaceid"></el-table-column>
                    <el-table-column :label="$t('message.限制次数')" align="center" prop="times"></el-table-column>
                    <el-table-column :label="$t('message.操作')" align="center">
                        <template slot-scope="scope">
                            <span class="canclick" style="margin-left:10px" @click="deleteinterfacelimit(scope.$index)">{{$t('message.删除')}}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <shade v-if="displayvisible">
            <plattable @outff='outff'></plattable>
        </shade>
        </div>
    </div>
</template>
<script>
import {rejecthttp,changeflagCLOSED} from "@/utils/request";
import shade from "@/components/shade/shade";
import plattable from "@/components/settings/plattable";
import commonUtil from '../../utils/commonUtil'
export default {
    components:{
        shade,
        plattable
    },
    data(){
        return{
            form:{
                appid:188,
                openid:'',
                openname:'',
                opencomment:'',
                name:'',
                pwd:''
            },
            isnew:false,
            showDetails:false,
            showpwd:true,
            interfacelimit:[],
            appIDs:[],
            data:[],
            limits:[],
            value:'IP',
            content:'',
            interfaceID:'',
            limittimes:'',
            targetappID:'',
            displayvisible:false,
            appIDpanelvisible:true,
            apicount:{
                maxapi:'',
                openApi:'',
                resDate:'',
                secondLimit:''
            }
        }
    },
    methods:{
        reset(){
            this.showDetails = false
            this.form.name=''
            this.form.pwd=''
            this.form.openname=''
            this.form.opencomment=''
            this.data=[]
            this.interfacelimit=[]
        },
        save(){
            rejecthttp(false,'post',"/manage/openapi/save",{
                appid:this.form.appid,
                openid:this.form.openid,
                name:this.form.openname,
                comment:this.form.opencomment,
                ipWhiteList:this.data,
                limitList:this.interfacelimit
            },this,(doc) => {
    		        changeflagCLOSED(doc,1,this)
    		        if(doc.data.Code == "MSGKEY_OK"){
                        this.form.openid = doc.data.data
                        this.isnew = false;
                        this.refresh()
    		        }
    		})
        },
        addiphost(){
        const h = this.$createElement;
        var that=this
        this.$msgbox({
          title: this.$t('message.添加IP或域名'),
          message: h('div', null, [
            h('span', {
                style:{
                    marginRight:'15px'
                }
            }, this.$t('message.类型')),
            h('el-radio', {
                props:{
                    value:that.value,
                    label:'IP'
                },
                ref:'radioip',
                on:{
                    change:e=>{
                        that.value='IP'
                        that.$refs.radioip.value='IP'
                        that.$refs.radiohost.value='IP'
                    }
                },
                style:{
                }
            },'IP'),
            h('el-radio', {
                props:{
                    value:that.value,
                    label:'host'
                },
                ref:'radiohost',
                on:{
                    change:e=>{
                        that.value='host'
                        that.$refs.radioip.value='host'
                        that.$refs.radiohost.value='host'
                    }
                }
            },this.$t('message.域名')),
            h('br', null, ''),
            h('div',{
                style:{
                    display:'flex',
                    marginTop:'10px',
                    height:'32px',
                    lineHeight:'32px'
                }
            },[
            h('span',{
                style:{
                    width:'50px'
                }
                } , this.$t('message.内容')),
            h('el-input', {
                props:{
                    value:that.content,
                    width:'200px',
                    size:'mini'
                },
                ref:'iphostinput',
                on:{
                    input:e=>{
                        console.log(e);
                        that.content=e
                        that.$refs.iphostinput.value=e
                    }
                }
            }, ''),
            ]),
            
          ]),
          showCancelButton: true,
          confirmButtonText: this.$t('message.确定'),
          cancelButtonText: this.$t('message.取消'),
        }).then(action => {
            var iptest=/^((25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))\.){3}(25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))$/g
            console.log();
            if(this.value=='IP'){
                if(iptest.test(this.content)){
            //     rejecthttp(false,'post',"/manage/openapi/insertwhitelist?appid="+this.form.appid+"&openid="+this.form.openid,{
            //     first:this.value=='IP'?0:1,
            //     second:this.content
            // },this,(doc) => {
    		//         changeflagCLOSED(doc,1,this)
    		//         if(doc.data.Code == "MSGKEY_OK"){
            //             this.refresh()
    		//         }
    		//         })
            this.data.push({'type':0,'content':this.content})
            }else{
                    this.$message({
                    type: "error",
                    message: 'ip格式错误 ip格式:255.255.255.255',
                });
                
            }
            }else{
            //     rejecthttp(false,'post',"/manage/openapi/insertwhitelist?appid="+this.form.appid+"&openid="+this.form.openid,{
            //     first:this.value=='IP'?0:1,
            //     second:this.content
            // },this,(doc) => {
    		//         changeflagCLOSED(doc,1,this)
    		//         if(doc.data.Code == "MSGKEY_OK"){
            //             this.refresh()
    		//         }
    		//         })
            this.data.push({'type':1,'content':this.content})
            }
            // if(iptest.test(this.content)){
            //     rejecthttp(false,'post',"/manage/openapi/insertwhitelist?appid="+'188',{
            //     first:this.value=='IP'?0:1,
            //     second:this.content
            // },this,(doc) => {
    		//         changeflagCLOSED(doc,1,this)
    		//         if(doc.data.Code == "MSGKEY_OK"){
            //             this.refresh()
    		//         }
    		//         })
            // }else{
            //         this.$message({
            //         type: "error",
            //         message: 'ip格式错误 ip格式:255.255.255.255',
            //     });
                
            // }
        });
        },
        addinterfacelimit(){
        const h = this.$createElement;
        var that=this
        this.$msgbox({
          title: this.$t('message.添加openApi调用限制'),
          message: h('div', null, [
            h('span', null, this.$t('message.接口ID')),
            h('el-select', {
                props:{
                    width:'200px',
                    size:'mini',
                    placeholder:'请选择接口ID',
                    popperAppendToBody:false,
                    popperClass:'select-popper'
                },
                ref:'selectView',
                on:{
                    change:e=>{
                        console.log(e);
                        that.interfaceID = e
                        that.$refs.selectView.value = e
                    }
                }
            }, [
            that.limits.map(it => {
              return h('el-option', {
                props: {
                  label: it.interfaceid,
                  key: it.interfaceid,
                  value: it.interfaceid,
                },
              });
            })
          ]),
            h('br', null, ''),
            h('div',{
                style:{
                    display:'flex',
                    marginTop:'10px',
                    height:'32px',
                    lineHeight:'32px'
                }
                },[
            h('span',{style:{width:'120px'}} , this.$t('message.限制次数')),
            h('el-input', {
                props:{
                    value:that.limittimes,
                    width:'100px',
                    size:'mini'
                },
                ref:'input2',
                on:{
                    input:e=>{
                        console.log(e);
                        that.limittimes=e
                        that.$refs.input2.value=e
                    }
                }
            }, ''),
            h('span',{style:{width:'200px'}} , ''),
            ]),
            
          ]),
          showCancelButton: true,
          confirmButtonText: this.$t('message.确定'),
          cancelButtonText: this.$t('message.取消'),
        }).then(action => {
            //     rejecthttp(false,'post',"/manage/openapi/addopenapilimit?appid="+this.form.appid,{
            //     openid:this.form.openid,
            //     interfaceid:this.interfaceID,
            //     times:this.limittimes
            // },this,(doc) => {
    		//         changeflagCLOSED(doc,1,this)
    		//         if(doc.data.Code == "MSGKEY_OK"){
            //             this.refresh()
    		//         }
    		//     })
            let n = this.limits.filter((a) => {
                return a.interfaceid === this.interfaceID;
                })[0].times
            let m = this.interfacelimit.find((a)=>{return a.interfaceid === this.interfaceID})
            if(this.limittimes>n || m){
                this.$message({
                    type: 'info',
                    message: m?'您新增的接口ID限制已存在':'您输入的限制次数超过系统设定的最大值，请修改重试'
                })
                this.interfaceID = ''
                this.limittimes = ''
            }else{
                this.interfacelimit.push({'openid':this.form.openid,'interfaceid':this.interfaceID,'times':this.limittimes})
                this.interfaceID = ''
                this.limittimes = ''
            }
        });
        },
        addnewopenid(){
            this.showDetails = true
            this.isnew = true
            this.form.openid = ''
            this.getrawdata()
        },
        showpwdfunc(){
            this.showpwd=!this.showpwd
        },
        deleteinterfacelimit(i){
            this.$confirm(this.$t('message.删除确认'), this.$t('message.删除提醒'), {
          confirmButtonText: this.$t('message.确定'),
          cancelButtonText: this.$t('message.取消'),
          type: 'warning'
        }).then(() => {
            // rejecthttp(false,'post',"/manage/openapi/removeopenapilimit?appid="+this.form.appid,row,this,(doc) => {
    		//         changeflagCLOSED(doc,1,this)
    		//         if(doc.data.Code == "MSGKEY_OK"){
            //             this.refresh()
    		//         }
    		//         })
          this.interfacelimit.splice(i,1)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
            console.log(i);
        },
        deleteopenid(row){
            rejecthttp(false,'get',"/manage/openapi/removeopenid?openid="+row.openid,{},this,(doc) => {
    		        changeflagCLOSED(doc,1,this)
    		        if(doc.data.Code == "MSGKEY_OK"){
    		         this.getappIDlist()
    		        }
    		        })
        },
        deleteiphost(i){
            this.$confirm(this.$t('message.删除确认'), this.$t('message.删除提醒'), {
          confirmButtonText: this.$t('message.确定'),
          cancelButtonText: this.$t('message.取消'),
          type: 'warning'
        }).then(() => {
            // rejecthttp(false,'post',"/manage/openapi/erasewhitelist?appid="+this.form.appid,row,this,(doc) => {
    		//         changeflagCLOSED(doc,1,this)
    		//         if(doc.data.Code == "MSGKEY_OK"){
            //             this.refresh()
    		//         }
    		//         })
          this.data.splice(i,1)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
            console.log(i);
        },
        apicontact(){
            console.log(this.displayvisible);
            this.displayvisible=!this.displayvisible
            console.log(123);
        },
        outff(){
            this.displayvisible=!this.displayvisible
        },
        setappID(row){
            this.$set(this.form,'openid',row.openid)
            this.$set(this.form,'openname',row.name)
            this.$set(this.form,'opencomment',row.comment)
            this.refresh()
            this.isnew = false
            this.showDetails=true
        },
        getinterfaceIDlist(){
            rejecthttp(false,'get',"/manage/openapi/getopenapilimit",{
               appid:this.form.appid,
               openid:this.form.openid
            },this,(doc) => {
    		        changeflagCLOSED(doc,0,this)
    		        if(doc.data.Code == "MSGKEY_OK"){
    		          console.log(doc.data);
                     this.interfacelimit=doc.data.data
    		        }
    		        })
        },
        getappIDlist(){
            rejecthttp(false,'get',"/manage/openapi/getappIDlist",{
            },this,(doc) => {
    		        changeflagCLOSED(doc,0,this)
    		        if(doc.data.Code == "MSGKEY_OK"){
    		          console.log(doc.data);
                     this.appIDs=doc.data.data
    		        }
    		        })
        },
        getlimitlist(){
            rejecthttp(false,'get',"/manage/openapi/getlimitlist?appid="+this.form.appid,{
            },this,(doc) => {
    		        changeflagCLOSED(doc,0,this)
    		        if(doc.data.Code == "MSGKEY_OK"){
    		          console.log(doc.data);
                     this.limits=doc.data.data
    		        }
    		        })
        },
        getwhitelist(){
            rejecthttp(false,'get',"/manage/openapi/getwhitelist",{
                appid:this.form.appid,
                openid:this.form.openid
            },this,(doc) => {
    		        changeflagCLOSED(doc,0,this)
    		        if(doc.data.Code == "MSGKEY_OK"){
    		          console.log(doc.data);
                     this.data=doc.data.data
    		        }
    		        })
        },
        getaccessinfo(){
            rejecthttp(false,'get',"/manage/openapi/getaccessinfo",{
                appid:this.form.appid,
                openid:this.form.openid
            },this,(doc) => {
    		        changeflagCLOSED(doc,0,this)
    		        if(doc.data.Code == "MSGKEY_OK"){
                        this.form.name=doc.data.data.first
                      this.form.pwd=doc.data.data.second
    		          console.log(doc.data);
    		        }
    		        })
        },
        resetaccess(){
            if(this.isnew)return
            rejecthttp(false,'get',"/manage/openapi/resetsecretkey",{
                appid:this.form.appid
            },this,(doc) => {
    		        changeflagCLOSED(doc,1,this)
    		        if(doc.data.Code == "MSGKEY_OK"){
                        this.form.pwd=doc.data.data
    		          console.log(doc.data);
    		        }
    		        })
        },
        getrawdata(){
            rejecthttp(false,'get',"/manage/openapi/openapistaticdata",{
                appid:this.form.appid
            },this,(doc) => {
    		        changeflagCLOSED(doc,0,this)
    		        if(doc.data.Code == "MSGKEY_OK"){
                        this.apicount.maxapi=doc.data.data.maxApi
                        this.apicount.openApi=doc.data.data.openApi
                        this.apicount.resDate=commonUtil.formatDate(doc.data.data.restData)
                        this.apicount.secondLimit=doc.data.data.secondLimit
    		        }
    		        })
        },
        refresh(){
            this.getwhitelist()
            this.getaccessinfo()
            this.getrawdata()
            this.getinterfaceIDlist()
            this.getappIDlist()
            this.getlimitlist()
        }
    },
    mounted(){
        this.getappIDlist()
        this.getlimitlist()
    }
}
</script>
<style  scoped>
    .containerht .inforemark{
        margin: 20px 0 20px 0;
        font-size: 12px;
        color: #595959;
    }
    .containerht .form{
        width: 60%;
    }
    .containerht .warring{
        margin-top: 20px;
        margin-bottom: 20px;
        color: rgb(231, 116, 116);
        font-size: 12px;
    }
    .containerht .canclick{
        color: #1ee2c8;
        cursor: pointer;
    }
    .containerht .percent123{
        height: 30%;
        margin-top: 10%;
        font-size: 18px;
        font-weight: 700;
    }
    .containerht .img{
        display: block;
        width: 100%;
        margin: auto;
        transform: translate(25%,100%);
    }
    .containerht .logo{
        width: 20%;
        height: 100%;
        align-content: center;
        float: left;
    }
    .containerht .contentc{
        width: 75%;
        font-size: 12px;
        height: 90%;
        float: right;
    }
    .containerht{
        /* background-color: #ccc; */
        padding: 20px;
        padding-top: 0;
    }
    .containerht .selecttab{
        height: 120px;
        text-align: center;
        background-color: #fff;
    }
    .containerht  .topinfo{
        height: 200px;
        margin-top: 20px;
        background-color: #fff;
    }
    .containerht .cinfo{
        height: 350px;
        margin-top: 20px;
        background-color: #fff;
    }
    .containerht .lastinfo{
        height: 450px;
        margin-top: 20px;
        background-color: #fff;
    }
    .containerht .pad{
        padding: 10px 20px 0 20px;
    }
    .containerht .tittle{
        font-size: 18px;
        font-weight: 600;
        color: #595959;
    }
    .containerht .ainfo{
        font-size: 14px;
        font-weight: 600;
        color: #595959;
    }
    .containerht .content{
        margin-top: 40px;
        display: flex;
        justify-content: space-between;
    }
    .containerht .child{
        height: 118px;
        border:1px solid #ccc;
        width:30%
    }
    .el-select .select-popper {
      z-index: 8888 !important;
      top: auto !important;
      left: auto !important
    }
</style>


// WEBPACK FOOTER //
// src/pages/settings/plat.vue